// extracted by mini-css-extract-plugin
export default {"general":"cN_ll","gridItem":"cN_f4","header":"cN_6","imgContainer":"cN_b7"};